// src/components/ListaHabitacionesMobile.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import HabitacionCardMobile from "./HabitacionCardMobile";

const ListaHabitacionesMobile = ({
  rooms,
  numGuests,
  incrementOccupants,
  handleReservation,
  totalNights,
  formatCurrency,
  totalPrice,
  manageOccupancy,
  occupiedRooms,
  handleDecrement,
  calculateOffer,
  startDate,
  endDate,
  // 🆕 vienen desde ReserveLayout
  currency, // "ARS" / "CLP"
  propertyId, // id de la propiedad
  mpPublicKey, // public key de MP del cliente
  mpLocale, // "es-AR" / "es-CL", etc.
}) => {
  // Agrupamos por nombre
  const groupedRooms = rooms.reduce((acc, room) => {
    if (!acc[room.name]) {
      acc[room.name] = {
        ...room,
        availability: [...room.availability],
      };
    } else {
      acc[room.name].availability = [
        ...new Set([...acc[room.name].availability, ...room.availability]),
      ];
    }
    return acc;
  }, {});

  const roomList = Object.values(groupedRooms);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 1,
        gap: 2,
        width: "100%",
        maxWidth: "100vw",
        boxSizing: "border-box",
      }}
    >
      {roomList.length > 0 ? (
        roomList.map((room) => {
          // 💱 por si el backend ya manda la moneda en la room
          const roomCurrency = (
            room.currency ||
            currency ||
            "ARS"
          ).toUpperCase();

          return (
            <Box key={`${room.roomId}-${room.name}`} sx={{ width: "100%" }}>
              <HabitacionCardMobile
                startDate={startDate}
                endDate={endDate}
                room={room}
                numGuests={numGuests}
                occupiedRooms={occupiedRooms}
                incrementOccupants={incrementOccupants}
                handleDecrement={handleDecrement}
                handleReservation={handleReservation}
                totalNights={totalNights}
                manageOccupancy={manageOccupancy}
                formatCurrency={formatCurrency}
                totalPrice={totalPrice}
                calculateOffer={calculateOffer}
                // 🆕 datos para el flujo de pago
                currency={roomCurrency}
                propertyId={propertyId}
                mpPublicKey={mpPublicKey}
                mpLocale={mpLocale}
              />
            </Box>
          );
        })
      ) : (
        <Typography variant="body1" sx={{ textAlign: "center", mt: 2, px: 1 }}>
          No hay habitaciones disponibles para las fechas seleccionadas.
        </Typography>
      )}
    </Box>
  );
};

export default ListaHabitacionesMobile;
